import axios from 'axios';
import appConfig from '@/config';
import { httpClient } from '@/utils/http-client';
import { logError } from '../../utils/logs';
class FileService {
    encoderClient;
    httpClient;
    constructor() {
        this.encoderClient = axios.create({
            baseURL: appConfig.encoderUrl
        });
        this.httpClient = httpClient;
    }
    async upload(data) {
        try {
            const response = await this.encoderClient.post('/upload', data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
        catch (error) {
            logError('Upload error', error);
        }
    }
    async reencode(filename, userId) {
        try {
            return this.encoderClient.post('/encode', { filename: 'uploads/' + filename, srcType: 'upload', user_id: userId });
        }
        catch (error) {
            logError('Upload error', error);
            return error;
        }
    }
    async poll(objectId) {
        try {
            return await this.encoderClient.get('/status/' + objectId);
        }
        catch (error) {
            logError('Polling Error', error);
        }
    }
}
export default FileService;
